import { Flex, Text } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";
import { BrandLogo } from "../../components/brand-logo";
import { LangSelector } from "./lang-selector";

export function ScanStreamUnavailable() {
  const { t } = useTranslation();

  return (
    <main
      role="alert"
      aria-live="assertive"
      className="fixed inset-0 z-[1] p-6 mobile-fa bg-white h-dvh overflow-hidden select-none"
    >
      <Flex direction="column" className="h-full">
        <Flex justify="between" mb="4">
          <BrandLogo />
          <LangSelector />
        </Flex>
        <Flex
          direction="column"
          flexGrow="1"
          gap="3"
          align="center"
          justify="center"
          className="pb-20 text-center"
        >
          <img src="/error-2.png" className="size-[160px]" alt="" />
          <Text className="font-semibold !text-[42px] leading-none">
            {t("scanStreamUnavailable")}
          </Text>
          <Text size="5" className="max-w-3xl">
            {t("scanStreamUnavailableDescription")}
          </Text>
        </Flex>
      </Flex>
    </main>
  );
}
